    import * as yup from 'yup';

    const dateOfBirthAndCityValidationSchema = yup.object().shape ({
        dateOfBirth: yup
            .string()
            .required('La date de décision est requise')
            .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Format attendu JJ/MM/AAAA'),
        postalCode: yup
            .string()
            .required('Le code postal est requis')
            .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
        city: yup
            .string()
            .required('La ville est requise'),
    });
    export default dateOfBirthAndCityValidationSchema;